import styled from 'styled-components';

// UTILITY
import { breakpoints } from '@/utility/breakpoints';

export const Container = styled.section`
  position: relative;
  padding: 80px 0;
  margin-bottom: 40px;

  ${breakpoints.down('xs')} {
    padding: 36px 0;
  }

  .rating-content {
    ${breakpoints.down('sm')} {
      text-align: center;
    }
  }

  .ratings-content {
    padding-top: 40px;
    display: flex;
    text-align: center;

    ${breakpoints.down('sm')} {
      flex-direction: column;
      align-items: center;
    }

    &__section {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    }

    &__rating-wrap {
      display: flex;
      margin-bottom: 16px;
    }

    &__icon {
      font-size: 32px;
      height: auto;
      margin-right: 8px;
    }

    &__mark {
      font-size: 6rem;
      line-height: 9rem;
      font-weight: 600;
      margin-bottom: 0;

      span {
        font-size: 4.2rem;
        font-weight: 400;
        vertical-align: bottom;
      }
    }
  }

  .write-review {
    padding-top: 60px;

    ${breakpoints.down('sm')} {
      padding-top: 40px;
    }

    &__rating {
      margin-top: 16px;
    }
  }

  .reviews-content {
    &__wrapper {
      &:first-of-type {
        .reviews-content__review {
          padding-top: 0;
        }
      }

      &:last-of-type {
        .MuiDivider-root {
          display: none;
        }

        .reviews-content__review {
          padding-bottom: 0;
        }
      }
    }

    &__review {
      padding: 40px 0;
    }

    &__empty {
      margin-top: 12px;
    }
  }

  .review {
    &__info {
      display: flex;
      align-items: flex-end;
      justify-content: space-between;
      margin-bottom: 24px;
    }

    &__title {
      margin-right: 10px;
    }
  }
`;

export default Container;
